import { DateRangePicker } from '@crazyegginc/hatch';

import { useFunnelEditorContext } from '../../funnel-editor-context';
import { TIMEZONES } from '/src/features/_global/constants';
import { DateRange } from '/src/components/date-time/DateRange';

export function DateRangeRow({ dateRange, lowerBoundary, upperBoundary, maxRange, resolverOptions }) {
  const { setDateRange } = useFunnelEditorContext();

  return (
    <div className="mb-2.5 flex justify-between items-center">
      <DateRange className="ml-1 text-header-3" dateRange={dateRange} resolverOptions={resolverOptions} />
      <div className="mr-1">
        <DateRangePicker
          lowerBoundary={lowerBoundary}
          upperBoundary={upperBoundary}
          startDate={dateRange?.start_date}
          endDate={dateRange?.end_date}
          special={dateRange?.special}
          setDateRange={setDateRange}
          setCommonDateRange={setDateRange}
          showCommonRanges={true}
          size="lg"
          timezone={TIMEZONES.UTC}
          showTimeZone={true}
          maxRange={maxRange}
        />
      </div>
    </div>
  );
}
